import React, {useEffect, useState} from "react";
import './styles/MyCourses.css';
import curriculaService from "../../../../services/curricula.service";
import Loading from "../../../helper/Loading";
import CoursePieChar from "./CoursePieChar";
import CourseDetail from "./CourseDetail";
import {Link} from "react-router-dom";
import CustomSweetAlert from "../../../helper/CustomSweetAlert";
import getErrorMessage from "../../../../config/ErrorMessage";
import withUrlParams from "../../../HOC/withUrlParams";
import withAuth from "../../../HOC/withAuth";
import i18n from "i18next";
import {useRecoilValue} from "recoil";
import {isOnlineState} from "../../../../states/states";

const MyCourses = (props) => {
    const {accessToken, uuid} = props;
    const [myCourses, setMyCourses] = useState(null);
    const [errorCode, setErrorCode] = useState("");
    const isOnline = useRecoilValue(isOnlineState);

    useEffect(() => {
        if (accessToken)
            getCourseInfo(accessToken);
    }, [uuid, accessToken]);

    const getCourseInfo = (token = '') => {
        if (isOnline) {
            curriculaService.getCourseInfo(token)
                .then(response => {
                    setErrorCode("");
                    setMyCourses(response.data);
                })
                .catch((error) => {
                    handlerError(error);
                });
        }else{
            setErrorCode("NO_NETWORK");
        }
    };

    const handlerError = (error) => {
        setErrorCode(error);
        if (error.response) {
            if (error.response.data.status === 401)
                setErrorCode("NOT_GRANTED");
            else if (error.response.data.status !== 500)
                setErrorCode(error.response.data.message)
        }
    };

    if (myCourses && !myCourses.length) {
        return <h6 className="no-courses"><p>{i18n.t('no_course_yet')}.</p></h6>;
    }

    if (myCourses) {
        return (
            <React.Fragment>
                {myCourses ? myCourses.map((myCourse, index) => {
                    let percentComplete = Math.ceil((myCourse.completedLessons / myCourse.numberOfLessons) * 100);
                    if (myCourse.completionType === 1 && myCourse.finalTestCorrectRate) {
                        percentComplete = Math.ceil(myCourse.finalTestCorrectRate * 100);
                    }
                    return (
                        <Link key={index} to={isOnline ? `/my-lessons?uuid=${uuid}&curr_code=${myCourse.curriculumCode}` : `/my-courses?uuid=${uuid}`}>
                            <div className="course-item">
                                <CoursePieChar myCourse={myCourse} percentComplete={percentComplete}/>
                                <CourseDetail myCourse={myCourse} percentComplete={percentComplete}/>
                            </div>
                        </Link>
                    )
                }) : <></>}
            </React.Fragment>
        );
    } else if (errorCode) {
        return <CustomSweetAlert showConfirm={false} text={getErrorMessage(errorCode)}/>;
    } else if(!isOnline) {
        return <CustomSweetAlert show={true} text={i18n.t('NO_NETWORK')} showConfirm={false}/>;
    }
    return <Loading/>
};

export default withUrlParams(withAuth(MyCourses));